// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2HfvC","ThumbZoom":"ChapterPlayer_ThumbZoom__2gZ6i"};